import type { Product } from '../types';
import type { JiraProjectType } from '../ui/modal/__generated__/editionBenefitsModalRelayQuery.graphql';

export const getProjectType = (product: Product): JiraProjectType => {
	switch (product) {
		case 'jira-service-management':
			return 'SERVICE_DESK';
		case 'jira-customer-service':
			return 'CUSTOMER_SERVICE';
		case 'jira':
			return 'SOFTWARE';
		case 'jira-product-discovery':
			return 'PRODUCT_DISCOVERY';
		case 'confluence':
			throw new Error('Confluence is not supported');
		default:
			throw new Error('Product not supported');
	}
};
